export enum UserRole {
  SuperAdmin = 'SuperAdmin',
  Patient = 'Patient',
  Specialist = 'Specialist',
  PracticeAdministrator = 'PracticeAdministrator',
  Des = 'DES',
  Admin = 'Admin',
}
